<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useLayout } from '@/layout/composables/layout';
import { useRouter } from 'vue-router';
const { onMenuToggle, toggleDarkMode, isDarkTheme } = useLayout();

const router = useRouter();

const logoUrl = computed(() => {
    if (!isDarkTheme.value) {
        return `/images/dark_outpost_logo.png`;
    } else {
        return `/images/light_outpost_logo.png`;
    }
});

const getBlogName = computed(() => {
    if (window.blogDto && window.blogDto.blog_name) {
        return window.blogDto.blog_name;
    }

    return `Outpost`;
});
const getBlogPlan = computed(() => {
    if (window.blogDto && window.blogDto.blog_url) {
        return window.blogDto.subscription_plan_name;
    }

    return `Outpost`;
});
const getUserEmail = computed(() => {
    if (window.userDto && window.userDto.email) {
        return window.userDto.email;
    }
    return null
});
const getUserName = computed(() => {
    if (window.userDto && window.userDto.name) {
        return window.userDto.name;
    }
    return 'Profile'
});
const getUserRole = computed(() => {
    if (window.userDto && window.userDto.role) {
        return window.userDto.role;
    }
    return null
});

const topbarMenuClasses = computed(() => {
    return {
        'layout-topbar-menu-mobile-active': topbarMenuActive.value
    };
});

const userMenu = ref();
const userMenuItems = ref([
    {
        label: 'Profile',
        items: [
            {
                label: 'Home',
                icon: 'pi pi-home',
                command: () => {
                    router.push('/');
                }
            },
            {
                label: 'Logout',
                icon: 'pi pi-sign-out',
                command: () => {
                    document.getElementById('logout-form').submit();
                }
            }
        ]
    }
]);


const userMenuToggle = (event) => {
    userMenu.value.toggle(event);
};
</script>

<template>
    <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <Button class="layout-menu-button layout-topbar-action" @click="onMenuToggle" severity="secondary">
                <i class="pi pi-bars"></i>
            </Button>

            <router-link to="/" class="layout-topbar-logo">
                <img :src="logoUrl" alt="Outpost Logo" />
            </router-link>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <Button type="button" class="layout-topbar-action" @click="toggleDarkMode" severity="secondary">
                    <i :class="['pi', { 'pi-moon': isDarkTheme, 'pi-sun': !isDarkTheme }]"></i>
                </Button>
            </div>

            <Button
                class="layout-topbar-menu-button layout-topbar-action" severity="secondary" @click="userMenuToggle"
            >
                <i class="pi pi-ellipsis-v"></i>
            </Button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
                    <Button type="button" class="layout-topbar-action" @click="userMenuToggle" severity="secondary">
                        <i class="pi pi-user"></i>
                        <span>Profile</span>
                    </Button>
                </div>
            </div>

            <Menu ref="userMenu" id="overlay_menu" :model="userMenuItems" :popup="true">
                <template #start>
                            <span class="inline-flex flex-column p-2 pl-2 max-w-20rem">
                                <span class="text-primary font-bold">{{ getBlogName }}</span>
                                <span class="mt-2">Plan: <span class="font-semibold">{{ getBlogPlan }}</span></span>
                            </span>
                </template>
                <template #submenuheader="{ item }">
                    <span class="text-primary font-bold">{{ item.label }}</span>
                </template>
                <template #end>
                    <div class="relative overflow-hidden w-full border-0 bg-transparent flex items-start p-2 hover:bg-surface-100 dark:hover:bg-surface-800 rounded-none cursor-pointer transition-colors duration-200" severity="secondary">
                        <span class="inline-flex flex-column align-items-start">
                            <span class="font-sm font-semibold">{{ getUserName }}</span>
                            <span class="font-sm">{{ getUserEmail }}</span>
                            <span class="text-sm">{{ getUserRole }}</span>
                        </span>
                    </div>
                </template>
            </Menu>

        </div>
    </div>
</template>

<style lang="scss" scoped></style>
